






import Vue from 'vue'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'
import NumberField from '@/components/NumberField.vue'

interface ComponentData {
  value: number | null
}

export default Vue.extend({
  name: 'AdditionalFieldsDecimalNumber',

  components: {
    NumberField
  },

  props: {
    item: {
      type: Object as () => AdditionalField
    }
  },

  data (): ComponentData {
    return {
      value: null
    }
  },

  watch: {},

  methods: {
    onValueChange (): void {
      const payload: AdditionalFieldItem = {
        parentType: this.item.type,
        componentId: this.item.componentId,
        value: this.value || this.value == 0 ? this.value.toString() : '',
        designation: '',
        id: 0,
        groupId: this.item.groupId,
        project: this.item.project
      }

      this.$emit('onValueChange', payload)
    }
  },

  created () {
    if(this.item) {
      this.value = this.item.value ? parseFloat(this.item.value) : null
    }
  }

})
